import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { FaIcon } from '../../common/fa_icons';

const ProductListClearItem = ({ handleClick, label }) => (
  <li onClick={handleClick}
    data-label={label}
    className="clear-item"
  >
    <FaIcon iconName="times" tagName="span" />
    <RosettaFormattedMessage parentFilename={__filename}
      id="clear"
      description="Clear message for the product list filter"
      defaultMessage="clear"
      children={(__html) => <a dangerouslySetInnerHTML={{ __html }} />}
    />
  </li>
);

ProductListClearItem.propTypes = {
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

export default ProductListClearItem;
